/* global debounce, attachEvent */

// *******************************************************************************
// 1.0 - Add class to body after some scroll
// *******************************************************************************


window.addEventListener('spectoCmsContentLoaded', () => {
// Debounce the function to prevent multiple executions on scroll event
  window.debounceScroll = injection.debounce(() => {
    injection.addScrollingClass();
  }, 50);

// window.addEventListener('scroll', debounceScroll);
  window.onscroll = function() {
    debounceScroll();
  };

// *******************************************************************************
// 2.0 - Open mobile menu
// *******************************************************************************

  injection.attachEvent('.mobile-hamburger', 'click', (ev) => {
    ev.preventDefault();

    // Open menu
    document.body.classList.toggle('is-open-menu');
    const hamburger = ev.target.closest('.mobile-hamburger');

    const isOpen = hamburger.classList.contains('is-open');

    hamburger.classList.toggle('is-open', !isOpen);
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

// *******************************************************************************
// Set top paddings and top offsets based on header
// *******************************************************************************

  window.addEventListener('load', injection.setOffsets);
  window.addEventListener('resize', injection.setOffsets);
});
